var _defs, _rect, _rect2, _path, _path2, _rect3, _circle, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg10329IconServiceIntune(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a9ed4d43-c916-4b9a-b9ca-be76fbdc694c",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aaede26b-698f-4a65-b6db-859d207e2da6",
    x1: 8.05,
    y1: 11.32,
    x2: 8.05,
    y2: 1.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5ea0ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc54987f-34ba-4701-8ce4-6eca10aff9e9",
    x1: 8.05,
    y1: 15.21,
    x2: 8.05,
    y2: 11.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1490df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#1f56a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a5434fd8-c18c-472c-be91-f2aa070858b7",
    x1: 8.05,
    y1: 7.87,
    x2: 8.05,
    y2: 4.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2ebff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0fffd"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-intune-329") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.26,
    width: 15.1,
    height: 10.06,
    rx: 0.5,
    fill: "url(#aaede26b-698f-4a65-b6db-859d207e2da6)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.34,
    y: 2.1,
    width: 13.42,
    height: 8.39,
    rx: 0.28,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.08,14.37c-1.5-.23-1.56-1.31-1.55-3h-3c0,1.74-.06,2.82-1.55,3a.87.87,0,0,0-.74.84h7.54A.88.88,0,0,0,11.08,14.37Z",
    fill: "url(#bc54987f-34ba-4701-8ce4-6eca10aff9e9)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.17,5.91H10.29a2.31,2.31,0,1,0,0,.92H11v9.58a.33.33,0,0,0,.33.33h5.83a.33.33,0,0,0,.33-.33V6.24A.33.33,0,0,0,17.17,5.91Z",
    fill: "#32bedd"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.62,
    y: 6.82,
    width: 5.27,
    height: 8.7,
    rx: 0.12,
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.05,
    cy: 6.41,
    r: 1.46,
    opacity: 0.9,
    fill: "url(#a5434fd8-c18c-472c-be91-f2aa070858b7)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.88,10.82,13.76,9.7a.06.06,0,0,0-.1.05v.68a.06.06,0,0,1-.06.06H11v.83H13.6a.06.06,0,0,1,.06.06v.69a.06.06,0,0,0,.1,0L14.88,11A.12.12,0,0,0,14.88,10.82Z",
    fill: "#0078d4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10329IconServiceIntune);
export default __webpack_public_path__ + "static/media/10329-icon-service-Intune.d33b08305ce10a82c17d545de8cd06ea.svg";
export { ForwardRef as ReactComponent };